import httpClient from "./httpClient";

const END_POINT = "/orgs";

const getOrgs = () => httpClient.get(END_POINT);

export { getOrgs };
